import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import classNames from 'classnames';
import GatsbyImg from 'gatsby-image';

import getExcerpt from '../../utils/get-excerpt';
import getGraphQlImage from '../../utils/get-graphql-image';

const ArchiveCardSkeleton = ({ content, excerpt, image, hasCategory, hasDate, excerptLength, isListing }) => {
  const link = `/`;
  const generatedExceprt = getExcerpt(content, excerpt, excerptLength);
  const imageObj = getGraphQlImage(image);

  return (
    <article
      className={classNames('archive-card-skeleton', {
        'archive-card-skeleton--listing': isListing,
        'archive-card-skeleton--has-image': imageObj,
      })}
    >
      <header className="archive-card-skeleton__header">
        <span className="archive-card-skeleton__title"></span>

        {hasCategory && (
          <div className="archive-card-skeleton__categories">
            <span className="archive-card-skeleton__category"></span>
          </div>
        )}
        {hasDate && <time className="archive-card-skeleton__date">{date}</time>}
      </header>
      {imageObj && (
        <div className="archive-card-skeleton__image-wrapper">
          <Link to={link}>
            <GatsbyImg className="archive-card-skeleton__image" image={imageObj} alt={`${title} image`} />
          </Link>
        </div>
      )}
      {generatedExceprt && (
        <p className="archive-card-skeleton__excerpt">
          <span
            className="archive-card-skeleton__excerpt-text"
            dangerouslySetInnerHTML={{ __html: generatedExceprt }}
            aria-hidden="true"
          />
        </p>
      )}
      <span className="archive-card-skeleton__cta"></span>
    </article>
  );
};

ArchiveCardSkeleton.defaultProps = {
  image: null,
  excerpt: null,
  excerptLength: 134,
  isListing: false,
  hasCategory: false,
  hasDate: false,
};

ArchiveCardSkeleton.propTypes = {
  content: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  image: PropTypes.shape({}),
  excerptLength: PropTypes.number,
  isListing: PropTypes.bool,
  hasCategory: PropTypes.bool,
  hasDate: PropTypes.bool,
};

export default ArchiveCardSkeleton;
